// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__cm14j","info":"UpdateTermsInfo_info__3LIy6"};